import { API_URL } from "../config/config";
import { getRequest } from "../utils/axiosUtils";
import buildQueryParams from "../utils/buildQueryParams";

export const fetchDeletedAccountList = async ({
  filter,
  setUserData,
  page,
  limit,
  skip,
  verification = false,
  isSelfieVerification = false,
  isIdVerification = false,
  searchTerm,
}) => {
  const { country, state, city, dateRange, gender, activeVerificationTab, utm_payload, sortBy, sortOrder, profileCompilation,requestType,statsType, source, channel, campaign, adset, creative, platform, from, to } = filter;

  const queryParams = buildQueryParams({
    country,
    state,
    city,
    gender,
    dateRange,
    verification,
    activeVerificationTab,
    page,
    limit,
    skip,
    isSelfieVerification,
    isIdVerification,
    searchTerm,
    utm_payload,
    sortBy,
    sortOrder,
    profileCompilation,
    requestType,
    statsType,
    ...(source ? { source } : {}),
    // Channel-attribution node params — forwarded only when the deleted list is
    // opened from the attribution tree's "Deleted" number (source==='attribution').
    ...(source === 'attribution' ? { channel, campaign, adset, creative, platform, from, to } : {}),
  });

  const res = await getRequest({
    url: `${API_URL}/admin/user/get-deleted-accounts?${queryParams}`,
  });
  if(!res) return
  if (res.status >= 200 && res.status < 300 && res.data) {
    setUserData(res.data.data.users);
    return res.data.data;
  } else {
    throw new Error(`Unexpected response code: ${res.status}`);
  }
};